import type { FC } from 'react';

import cn from 'classnames';

import { ZoomableImage } from './ZoomableImage';

export interface PostMediaImage {
  id: string;
  src: string;
  fullSrc: string;
  alt: string;
}

interface PostMediaFrameProps {
  images: PostMediaImage[];
  index?: number;
  className?: string;
}

// The fixed 4:3 frame keeps a tall image from stretching the post; object-contain scales it down without cropping.
export const PostMediaFrame: FC<PostMediaFrameProps> = ({ images, index, className }) => (
  <div data-testid="post-media-frame" className={cn('aspect-[4/3] overflow-hidden rounded-lg bg-black/5', className)}>
    <ZoomableImage
      images={images}
      index={index}
      className="block size-full"
      imageClassName="size-full object-contain"
    />
  </div>
);
